module.exports = __webpack_public_path__ + "static/b1__icon-53078a3fd07a3d79629d5e042971f23a.svg";